export default {"src":"/apac/_next/static/media/sheet.3c0ca7e9.svg","height":20,"width":16,"blurWidth":0,"blurHeight":0};